export default function (templateId) {
    const template = document.getElementById(templateId);
    if (!template) {
        throw new Error(`Template ${templateId} not found in document.`);
    }
    const fragment = document.createElement('div');
    fragment.insertAdjacentHTML('afterbegin', template.innerText.trim());
    return fragment.firstElementChild;
}